(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["delucca-loader"] && !Shopify.designMode) return;
  try {
    window.addEventListener('load', function () {
    document.body.classList.add('loaded');
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["delucca-product-gallery"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function () {
    // SWIPER
    swiperThumbs = new Swiper('.top__wrapper .swipper-thumbs', {
      spaceBetween: 10,
      slidesPerView: 4,
      freeMode: true,
      watchSlidesProgress: true,
      breakpoints: {
        992: {
          direction: 'vertical',
        },
        0: {
          direction: 'horizontal',
        },
      },
    });

    swiperVitrine = new Swiper('.top__wrapper .swipper-container', {
      spaceBetween: 10,
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
      },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      pagination: {
        el: '.swiper-pagination',
        type: 'fraction',
      },
      thumbs: {
        swiper: swiperThumbs,
      },
    });

    function markActiveSlide() {
      const inputActive = document.querySelector('input[data-current-checked="true"][data-featured-media-id]');
      if (!inputActive) return;
      const mediaId = inputActive.dataset.featuredMediaId;
      if (!mediaId) return;
      const slides = document.querySelectorAll('.swiper-slide');
      slides.forEach((slide, index) => {
        if (slide.dataset.mediaId === mediaId) {
          swiperVitrine.slideTo(index, 300);
        }
      });
    }

    // Vir com uma imagem selecionada
    // markActiveSlide();

    document.addEventListener('change', function (e) {
      if (e.target.matches('input[data-featured-media-id]')) {
        markActiveSlide();
      }
    });

    // Modal Video
    const modal = document.querySelector('.pdp-video-modal');
    const openBtn = document.querySelector('.product__badge-video');
    const closeBtn = modal?.querySelector('.pdp-video-close');
    const overlay = modal?.querySelector('.pdp-video-overlay');
    const iframe = modal?.querySelector('iframe');

    if (modal && openBtn && iframe) {
      const originalSrc = iframe.src;

      function openModal() {
        modal.hidden = false;
        document.body.style.overflow = 'hidden';
        iframe.src = originalSrc;
      }

      function closeModal() {
        modal.hidden = true;
        document.body.style.overflow = '';
        iframe.src = '';
        iframe.src = originalSrc;
      }
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && !modal.hidden) {
          closeModal();
        }
      });
      openBtn.addEventListener('click', openModal);
      closeBtn?.addEventListener('click', closeModal);
      overlay?.addEventListener('click', closeModal);
    }
  });
  } catch(e) { console.error(e); }
})();

})();
